import React from "react";
import { PANEL_COMPONENT_KEY_NAMES, PANEL_NAMES } from "./labels";
import { AnalysisType } from "./analysisConfig";

export type PanelType = keyof typeof PANEL_NAMES;
export type PanelComponentKeyType = keyof typeof PANEL_COMPONENT_KEY_NAMES;

export const ThicknessMax = 10.2;
export const ThicknessStep = 1;

/**
 * 패널이 갖는 속성
 */
export interface PanelConfig {
  /**DICOMPanel, VRPanel, Surface3DPanel .. */
  panelId: PanelType;
  /**axial, coronal, sagittal 구분용 */
  componentKey: PanelComponentKeyType;
  /**CPR, CrossSection 구분용 */
  className?: string;
}
export interface PanelCommonProps {
  className : string;
  panelConfig : PanelConfig;
  possibleProjection? : PanelComponentKeyType[];
  topLeftContent : JSX.Element[];
  topRightContent : JSX.Element[];
}

export const PANEL_CONFIG: Record<PanelType, PanelConfig[]> = {
  EmptyPanel: [{ panelId: 'EmptyPanel', componentKey: 'Empty' }],
  DICOMPanel: [
    { panelId: 'DICOMPanel', componentKey: 'Axial' },
    { panelId: 'DICOMPanel', componentKey: 'Coronal' },
    { panelId: 'DICOMPanel', componentKey: 'Sagittal' },
    { panelId: 'DICOMPanel', componentKey: 'FourChamber'},
    { panelId: 'DICOMPanel', componentKey: 'TwoChamber'},
    { panelId: 'DICOMPanel', componentKey: 'ShortAxis'},
    { panelId: 'DICOMPanel', componentKey: 'Direction'},
  ],
  VRPanel: [{ panelId: 'VRPanel', componentKey: 'VR' }],
  Surface3DPanel: [
    { panelId: 'Surface3DPanel', componentKey: 'Surface3D' },
    { panelId: 'Surface3DPanel', componentKey: 'WallThickness' },
  ],
  ReportPanel: [
    { panelId: 'ReportPanel', componentKey: 'Report' },
  ],
  CPRPanel: [
    { panelId: 'CPRPanel', componentKey: 'CPR'},
  ],
  CrossSectionPanel: [
    { panelId: 'CrossSectionPanel', componentKey: 'CrossSection'}
  ],
  PlotPanel:[
    { panelId: 'PlotPanel', componentKey: 'Graph'},
    { panelId: 'PlotPanel', componentKey: 'Histogram'}
  ]
};

export type EdgePosition =
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

export interface EdgeOverlay{
  content : React.ReactNode;
  visible?: boolean;
}
export type PanelOverlayConfig ={
  [position in EdgePosition]?: EdgeOverlay;
}

export const getProjectionList  = (analysisType : AnalysisType):PanelComponentKeyType[]=>{
  switch (analysisType) {
    case 'preview':
      return ['Axial','Coronal','Sagittal']
    case 'MPR':
      return ['Axial','Coronal','Sagittal','VR']
    case 'segmentation':
      return ['Axial','Coronal','Sagittal','VR','Surface3D']
    case 'FFR':
    case 'wallthickness':
      return ['Axial','Coronal','Sagittal','Surface3D']
    case 'isr':
    case 'stenosis':
    case 'plaque':
    case 'fai':
      return ['Axial','Coronal','Sagittal']
    case 'empty':
    default:
      return [];
  }
}
